import { takeLatest, select, call, put } from "redux-saga/effects";
import axios from "axios";
import log from "loglevel"

import getEnvParam from "../../utils/getEnvParam";

const getCdsFromAPi = (token) => {
    return new Promise((resolve, reject) => {
        return axios.request(getEnvParam("REACT_APP_BFF_URL_REST") + "/cd/listar", {
            method: "GET",
            headers: {
                "NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CD"),
                "Content-Type": "application/json",
                "Authorization": token
            },
        })
            .then(response => response.status !== 200 ? reject(response) : response)
            .then(response => response.data)
            .then(response => resolve(response))
            .catch(error => {
                reject(error);
                log.info(error);
            });
    });

};


//generators
function* getCds() {

    try {
        const authentication = state => state.authentication;
        const { token } = yield select(authentication);

        const data = yield call(getCdsFromAPi, token);

        yield put({ type: "CD_LIST", payload: data });

    } catch (error) {
        //Este bloco em producao deverah ser melhor tratado e
        //apresentar uma mensagem para o cliente
        log.info(error);
    }

}


// //Generator function
export function* getCdsWatcher() {
    yield takeLatest("GET_CDS", getCds);
}
